require('./components/slide-text')
require('./components/menu-vertical')
require('./components/slide-recrument')

function header() {
    //click button search
    $(".search-btn").click(function () {
        $(".search-inp").toggleClass("active");
        $(".navbar-collapse.menu").toggleClass("onSearch")
        headerMenu()
    })
}

function headerMenu() {
    //change margin of menu
    setTimeout(function () {
        if($(".right-menu").length) {
            const containerWidth = $(".right-menu").offset().left - (
                $(".logo").offset().left + $(".logo").outerWidth()
            )

            const menuWidth = $(".menu .navbar-nav").width();
            const margin = (containerWidth - menuWidth) / 2;
            // console.log(containerWidth, menuWidth, margin)
            $(".menu").css({
                marginLeft: $(".logo").outerWidth() + margin - 45 + "px"
            })
        }
    }, 300)
}

function homeSlide() {
    $('.slide-kc .carousel').on('slide.bs.carousel', function (e) {
        const index = e.to;
        $(this).parents(".slide-kc").find(".title-group .active").removeClass("active")
        $($(this).parents(".slide-kc").find(".title-group .item")[index]).addClass("active")

    })
}

function homeScopeHover() {
    $(".project-item").hover(function () {
        const bottomLine = $(this).find(".bottom-line");
        const bottomLineWidth = $(bottomLine).width();
        const bottomHoverWidth = $(bottomLine).attr("data-width-hover");
        $(bottomLine).attr("data-width", bottomLineWidth).width(bottomLineWidth + Number(bottomHoverWidth))
    }, function () {
        const bottomLine = $(this).find(".bottom-line");
        const bottomWidth = $(bottomLine).attr("data-width");
        $(bottomLine).width(bottomWidth)
    })
    $(window).resize(function () {
        $(".project-item .bottom-line").removeAttr("data-width").removeAttr("style");
    })
}

function menuMobile() {
    //click submenu
    $(".nav-item.has-sub-menu").click(function () {
        if ($(this).hasClass("active")) {
            $(this).removeClass("active").find(".sub-menu").stop(true, true).slideUp();
        } else {
            $(this).addClass("active").find(".sub-menu").stop(true, true).slideDown();
        }
    })

    //click show menu mobile
    $(".navbar-toggler").click(function () {
        if ($(this).hasClass("active")) {
            $(this).removeClass("active");
            $("html,body").removeClass("no-scroll");
            $(".menu-mobile").stop(true, true).fadeOut({
                duration: 300
            });
        } else {
            $(this).addClass("active")
            $("html,body").addClass("no-scroll");
            $(".menu-mobile").stop(true, true).fadeIn({
                duration: 300
            });
        }
    })
    $(window).resize(function () {
        $(this).removeClass("active")
        $(".menu-mobile").stop(true, true).fadeOut({
            duration: 300
        });
    });
}

function changeSelectPost() {
    $('.search-select.post').on('changed.bs.select', function (e, clickedIndex, isSelected, previousValue) {
        window.location.href = "/" + $(this).val()
    });
}

function changeTabField() {
    //active lại tab theo url
    const $fieldPage = $(".tab-field-main");
    if ($fieldPage.length) {
        const pathName = window.location.pathname;
        $fieldPage.find(`.nav-tabs .nav-item[data-url='${pathName}']`).tab("show")
    }
    //điều chỉnh lại hover trên menu và slide.
    $(".tab-field-main").off("click").on("click", ".nav-item", function () {
        const newBanner = $(this).data("banner");
        const newName = $(this).data("name");
        const newLink = $(this).data("url");
        const navActive = $('.nav-item.dropdown.active')
        if (newLink) {
            $("#slide-field").find('.img').css('background-image', 'url(' + newBanner + ')')
            $("#slide-field").find('.title').text(newName)
            navActive.find('.active').removeClass('active')
            navActive.find(`[data-href='${newLink}']`).addClass('active')
            window.history.pushState('', '', newLink);
        }
    })
}

function aboutScollTop() {
    setTimeout(function () {
        const hash = window.location.hash;
        const $aboutContent = $(".item-body-about")
        if (!$aboutContent.length) return;
        if (hash == "#noscroll") return;
        $("html, body").animate({
            scrollTop: $aboutContent.offset().top
        }, 500)
    }, 200)
}

function zoomImg() {
    mediumZoom('.container .content-8.active .item-info-banner-chart img', {
        background: '#ffffff'
    })
}



const slideIconHomepage = () => {
    $('.responsive-student').slick({
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 4,
        responsive: [{
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                    infinite: true,
                    dots: false
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            }
        ]
    });

    $('.responsive-homepage').slick({
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 5,
        slidesToScroll: 5,
        responsive: [{
                breakpoint: 1024,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 5,
                    infinite: true,
                    dots: false
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            }
        ]
    });

    $('.libraryMedia').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        infinite: false,
        autoplaySpeed: 2000,
        dots: true,
        responsive: [{
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });

    $('.libraryAlumni').slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay: true,
        infinite: false,
        autoplaySpeed: 2000,
        dots: true,
        responsive: [{
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });

    $('.item-slide-student-face').slick({
        slidesToShow: 6,
        slidesToScroll: 1,
        autoplay: true,
        infinite: false,
        autoplaySpeed: 2000,
        dots: true,
        responsive: [{
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    infinite: false,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });
}

// slide home
const homepageSlide = () => {
    const content = $(".homepageSlide").find(".carousel-item.active .caption-slide-img").html();
    $(".img-slide-caption .caption-slide-img").html(content);

    const href = $(".homepageSlide").find(".carousel-item.active a").attr("href");
    $(".img-slide-caption a").attr("href", href);

    $(".homepageSlide").on('slide.bs.carousel', function (e) {
        // do something…
        const index = e.to;
        const content = $($(this).find(".caption-slide-img")[index]).html();
        $(".img-slide-caption .caption-slide-img").html(content);
        const href = $($(this).find("a")[index]).attr("href");
        $(".img-slide-caption a").attr("href", href);
    })
}


// scroll top
$(document).ready(function () {
    $(window).scroll(function () {
        if ($(this).scrollTop() > 20) {
            $('#toTopBtn').fadeIn();
        } else {
            $('#toTopBtn').fadeOut();
        }
    });

    $('#toTopBtn').click(function () {
        $("html, body").animate({
            scrollTop: 0
        }, 1000);
        return false;
    });
});

// End scroll top

$("document").ready(function () {
    header();
    headerMenu();
    homeSlide();
    menuMobile();
    homeScopeHover();
    changeSelectPost();
    changeTabField();
    aboutScollTop();
    zoomImg();

    slideIconHomepage();
    homepageSlide();
})

$(window).resize(function () {
    headerMenu()
})
